import Sales from '../components/reports/Vision-general-de-ventas.vue';
import Ranking from '../components/reports/Ranking-por-producto.vue';
import Reportz from '../components/reports/Report-Z.vue';
import Ivasales from '../components/reports/iva-ventas.vue';
import ReportReceipt from '../components/reports/Receipt-report.vue';
import ReportPayorder from '../components/reports/Payorder-report.vue';
import Ivapurchases from '../components/reports/iva-compras.vue';
import Purchases from '../components/reports/Vision-general-de-compras.vue';
import Stock from '../components/reports/Stock-minimo.vue';
import Stockvalued from '../components/reports/Stock-valorizado.vue';
import Stockmovements from '../components/reports/stock-report.vue';
import Funds from '../components/reports/Movimientos-de-caja.vue';
import Cccbalancestodate from '../components/reports/ccc-balances-to-date.vue';
import Pacbalancestodate from '../components/reports/Lista-saldo-proveedores.vue';
import Salesclerksranking from '../components/reports/Ranking-piechart.vue';
import Cccbysalesclerk from '../components/reports/ccc-por-vendedor.vue';
import EmptyReport from '../components/reports/EmptyReports.vue';
import IndexReports from '../components/reports/Index-reports.vue';
import yearlyConsolidated from '../components/reports/Consolidado-anual.vue';
import Consolidated from '../components/reports/Consolidado.vue';

const reports = {
    path: '/reports',
    meta: {
        requiresAuth: true
    },
    component: EmptyReport,
    // se crea un componente vacio para que funcione bien, siguiendo esta guia https://dev.to/berniwittmann/my-approach-on-vue-router-architecture-and-nested-routes-2kmo
    children: [
        { path: '', component: IndexReports, name: 'Reportes' },
        { path: 'sales', component: Sales, name: 'Visión general de ventas' },
        { path: 'ranking', component: Ranking, name: 'Ranking por producto' },
        { path: 'reportz', component: Reportz, name: 'Reporte Z' },
        { path: 'ivasales', component: Ivasales, name: 'IVA ventas' },
        { path: 'reportReceipt', component: ReportReceipt, name: 'Listado de recibos' },
        { path: 'reportPayorder', component: ReportPayorder, name: 'Listado de órdenes de pago' },
        { path: 'ivapurchases', component: Ivapurchases, name: 'IVA compras' },
        { path: 'purchases', component: Purchases, name: 'Visión general de compras' },
        { path: 'stock', component: Stock, name: 'Stock mínimo' },
        { path: 'stockvalued', component: Stockvalued, name: 'Stock valorizado' },
        { path: 'stockmovements', component: Stockmovements, name: 'Reporte de Movimientos de stock' },
        { path: 'funds', component: Funds, name: 'Movimientos de caja' },
        { path: 'cccbalancestodate', component: Cccbalancestodate, name: 'Saldos de clientes a la fecha' },
        { path: 'pacbalancestodate', component: Pacbalancestodate, name: 'Saldos de proveedores a la fecha' },
        { path: 'salesclerksranking', component: Salesclerksranking, name: 'Ranking de vendedores' },
        { path: 'cccbysalesclerk', component: Cccbysalesclerk, name: 'Cuentas por vendedor' },
        { path: 'Consolidado', component: yearlyConsolidated, name: 'Consolidado anual — Ventas vs. Egresos' },
        { path: 'Consolidated', component: Consolidated, name: 'Consolidado anual — Cajas vs. Egresos' },
    ],
};

export default reports;